<template>
  <boxwrap class="messages--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <select-list
          ref="toolbarNav"
          class="toolbar-nav"
          :title="$route.params.status"
          v-model="selectedStatus"
        >
          <select-option
            value="all"
            name="all"
          >
            <span>all</span>
          </select-option>

          <select-option
            value="user"
            name="user"
          >
            <span>user</span>
          </select-option>

          <select-option
            value="code"
            name="code"
          >
            <span>code</span>
          </select-option>

          <select-option
            value="level"
            name="level"
          >
            <span>level</span>
          </select-option>

          <select-option
            value="code&level"
            name="code & level"
          >
            <span>code & level</span>
          </select-option>

          <select-option
            value="deleted"
            name="deleted"
          >
            <span>deleted</span>
          </select-option>

        </select-list>
        <search
          class="search-bar-wrap -withdropdown"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>
        <button
          class="btn--create"
          title="create"
          @click="showCreate = true"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--delete"
          title="delete"
          v-if="selected.length > 0"
          @click="deleteMessages"
        >
          <i class="ico--delete"></i>
        </button>

        <button
          class="btn--restore"
          title="restore"
          v-if="selected.length > 0"
          @click="restoreMessages()"
        >
          <i class="ico--restore"></i>
        </button>

        <button
          class="btn--message"
          title="message"
          @click="messageUser()"
        >
          <i class="ico--message"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>
      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
      >
        <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td name="checkbox">
                <checkbox>
                  <input type="checkbox" @click="checkAll(messages)" />
                </checkbox>
              </tbl-td>
              <tbl-td
                name="id"
                :sort="true"
                @click.native="sort('id')"
                v-if="checkCol('id', tblSetting)"
              > no </tbl-td>
              <tbl-td
                name="created-at"
                :sort="true"
                @click.native="sort('created_at')"
                v-if="checkCol('created_at', tblSetting)"
              > created at </tbl-td>
              <tbl-td
                name="title"
                :sort="true"
                @click.native="sort('title')"
                v-if="checkCol('title', tblSetting)"
              > title </tbl-td>
              <tbl-td
                name="content"
                :sort="true"
                @click.native="sort('content')"
                v-if="checkCol('content', tblSetting)"
              > content </tbl-td>
              <tbl-td
                name="user"
                v-if="$route.params.status !== 'user' && checkCol('user_count', tblSetting)"
              > user count </tbl-td>
              <tbl-td
                name="login-id"
                :sort="true"
                @click.native="sort('login_id')"
                v-if="checkCol('login_id', tblSetting) &&
                  ($route.params.status === 'user' ||
                  $route.params.status === 'all' ||
                  $route.params.status === 'deleted')"
              > login id </tbl-td>
              <tbl-td
                name="login-name"
                :sort="true"
                @click.native="sort('login_name')"
                v-if="checkCol('login_name', tblSetting) &&
                  ($route.params.status === 'user' ||
                  $route.params.status === 'all' ||
                  $route.params.status === 'deleted')"
              > login name </tbl-td>
              <tbl-td
                name="level"
                :sort="true"
                @click.native="sort('level')"
                v-if="checkCol('level', tblSetting) &&
                  ($route.params.status === 'user' ||
                  $route.params.status === 'all' ||
                  $route.params.status === 'deleted')"
              > level </tbl-td>
              <tbl-td
                name="agent"
                :sort="true"
                @click.native="sort('agent')"
                v-if="checkCol('agent', tblSetting) &&
                  ($route.params.status === 'user' ||
                  $route.params.status === 'all' ||
                  $route.params.status === 'deleted')"
              > agent </tbl-td>
              <tbl-td
                name="admin"
                :sort="true"
                @click.native="sort('admin_id')"
                v-if="checkCol('admin', tblSetting)"
              > admin </tbl-td>
              <tbl-td
                name="updated-at"
                :sort="true"
                @click.native="sort('updated_at')"
                v-if="checkCol('updated_at', tblSetting)"
              > updated at </tbl-td>
              <tbl-td
                name="deleted-at"
                :sort="true"
                @click.native="sort('deleted_at')"
                v-if="checkCol('deleted_at', tblSetting)"
              > deleted at </tbl-td>
            </tbl-row>
          </tbl-head> <!-- tbl-head-->

          <tbl-body>
            <tbl-row
              v-for="(item, index) in messages"
              :key="item.id"
              @click.native="showModifyForm(index)"
              :class="{'is-deleted': item.deleted_at}"
            >
              <tbl-td name="checkbox">
                <checkbox
                  @click.native.stop
                >
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="item.id"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="id"
                v-if="checkCol('id', tblSetting)"
              >
                <span>
                  {{ generateNumber(index, query.page, query.rows, query.sort, messageCount || 0) }}
                </span>
              </tbl-td>

              <tbl-td
                name="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                <span>{{item.created_at | date}}</span>
              </tbl-td>

              <tbl-td
                name="title"
                v-if="checkCol('title', tblSetting)"
                :isHtml="true"
                :logs="item.title"
              >
              </tbl-td>

              <tbl-td
                name="content"
                v-if="checkCol('content', tblSetting)"
                :isHtml="true"
                :logs="item.content"
              >
              </tbl-td>

              <tbl-td
                name="user-count"
                v-if="$route.params.status !== 'user' && checkCol('user_count', tblSetting)"
              >
                {{ getUserCount(item.receiver) }}
              </tbl-td>

              <tbl-td
                name="user-id"
                v-if="checkCol('login_id', tblSetting) &&
                  ($route.params.status === 'user' ||
                  $route.params.status === 'all' ||
                  $route.params.status === 'deleted')"
                @click.native.stop
                @click.native="openUser(item.user_id, 'info/undeleted')"
              >
                <span>{{ item.user_login_id || '-' }}</span>
              </tbl-td>

              <tbl-td
                name="login-name"
                v-if="checkCol('login_name', tblSetting) &&
                  ($route.params.status === 'user' ||
                  $route.params.status === 'all' ||
                  $route.params.status === 'deleted')"
                @click.native.stop
                @click.native="openUser(item.user_id, 'bet-history/all')"
              >
                <span>{{ item.user_login_name || '-' }}</span>
              </tbl-td>

              <tbl-td
                name="level"
                v-if="checkCol('level', tblSetting) &&
                  ($route.params.status === 'user' ||
                  $route.params.status === 'all' ||
                  $route.params.status === 'deleted')"
              >
                <span>{{ item.level || '-' }}</span>
              </tbl-td>

              <tbl-td
                name="agent"
                v-if="checkCol('agent', tblSetting) &&
                  ($route.params.status === 'user' ||
                  $route.params.status === 'all' ||
                  $route.params.status === 'deleted')"
              >
                <span>{{ item.agents ? item.agents.agent_login_name : '-' }}</span>
              </tbl-td>

              <tbl-td
                name="admin"
                v-if="checkCol('admin', tblSetting)"
              >
                <span>{{ item.admin_login_name || '-' }}</span>
              </tbl-td>

              <tbl-td
                name="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                <span>{{ getReadAt(item.read) | date }}</span>
              </tbl-td>

              <tbl-td
                name="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                <span>{{item.deleted_at | date}}</span>
              </tbl-td>

            </tbl-row>
          </tbl-body> <!--tbl-body-->
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="messageCount"
            :limit="query.rows"
            :rows="query.rows"
            v-model="query.page"
            @page="trigger"
          ></pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents> <!-- boxwrap-contents-->

    <modal
      class="modal--create-message"
      title="create message"
      v-if="showCreate"
      :activate="showCreate"
      @activate="showCreate = $event"
    >
      <template slot="body">
        <div class="form-con">

          <div class="form-items">
            <div class="form-lbl"><span>Login id</span></div>
            <div class="form-data">
              <input-suggestion
                @search="searchUser"
                v-model="messageModel.user"
                placeholder="Search User"
              >
                <span slot="selected">{{ messageModel.user ? messageModel.user.login_id : '' }}</span>
                <suggestion
                  slot="suggestion"
                  v-for="user in users"
                  :key="user.id"
                  :value="user"
                >
                  {{ user.login_id }}
                </suggestion>
              </input-suggestion>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>Title</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="title"
                  :options="quillTitleConfig"
                  v-model="messageModel.title"
                >
                </quill-editor>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>Content</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="textarea"
                  :options="quillContentConfig"
                  v-model="messageModel.content"
                ></quill-editor>
              </div>
            </div>
          </div> <!-- form-items -->

        </div> <!-- form-con-->
      </template>

      <template slot="footer">
        <button
          class="btn--confirm -withlabel"
          @click="addNewMessage()"
        >
          <i class="ico--create"></i>
          <span>create</span>
        </button>
      </template>
    </modal>

    <modal
      class="modal--modify-message"
      title="modify message"
      v-if="showModify"
      :activate="showModify"
      @activate="showModify = $event, selected = []"
    >
      <template slot="body">
        <div class="form-con">

          <div class="form-items">
            <div class="form-lbl"><span>User id</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ messageUpdateModel.user_login_id }}</span>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>User name</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ messageUpdateModel.user_login_name }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Read at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ getReadAt(messageUpdateModel.read) | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Created at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ messageUpdateModel.created_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Deleted at</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <span>{{ messageUpdateModel.deleted_at | date }}</span>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl -content"><span>Title</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="title"
                  :options="quillTitleConfig"
                  v-model="messageUpdateModel.title"
                >
                </quill-editor>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl -content"><span>Content</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <quill-editor
                  ref="content"
                  :options="quillContentConfig"
                  v-model="messageUpdateModel.content"
                >
                </quill-editor>
              </div>
            </div>
          </div> <!-- form-items -->

        </div> <!-- form-con-->
      </template>

      <template slot="footer">
        <button
          class="btn--modify -withlabel"
          @click="saveModify()"
        >
          <i class="ico--modify"></i>
          <span>modify</span>
        </button>
      </template>
    </modal>

    <message
      :showMessageUser="showMessageUser"
      @closeComponent="showMessageUser = $event"
    >
    </message>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import _ from 'lodash'
//= mixins
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'
import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

// == components
import Pagination from '@/components/base/Pagination'
import Modal from '@/components/base/Modal'
import Checkbox from '@/components/base/Checkbox'
import CheckDataList from '@/components/base/CheckDataList'
import Search from '@/components/base/search/Search'
import Message from '@/components/common/message/Message'
import TextArea from '@/components/base/TextArea'
import { quillEditor } from 'vue-quill-editor'

import '@/components/base/table/Table'
// import '@/components/layout/boxwrap/Boxwrap'
import '@/components/base/select/Select'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'Messages',

  components: {
    Pagination,
    Modal,
    Checkbox,
    CheckDataList,
    Search,
    Message,
    TextArea,
    'quill-editor': quillEditor
  },

  mixins: [ getListStatus, swal, checkAll ],

  data () {
    let query = Object.assign(
      {
        page: 1,
        rows: 50,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )
    return {
      query,
      selected: [],
      selectAll: false,
      filterStatus: 'all',
      messageModel: this.getDefaultModel(),
      messageUpdateModel: this.getDefaultModel(),
      searchInput: '',
      totalDataFetch: 0,
      showCreate: false,
      showModify: false,

      // flags
      isDataLoading: true,
      showDataLoading: false,
      isEmpty: false,
      showTblSettings: false,

      showMessageUser: false,

      filterBy: [
        {
          value: 'login_id',
          display: 'login id'
        },

        {
          value: 'login_name',
          display: 'login name'
        },

        {
          value: 'admin_id',
          display: 'admin'
        },

        {
          value: 'content',
          display: 'content'
        },

        {
          value: 'title',
          display: 'title'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },

        {
          value: 'updated_at',
          display: 'updated at'
        },

        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      tblSetting: 'support_messages',
      allCols: [
        {
          display: 'id',
          value: 'id'
        },
        {
          display: 'title',
          value: 'title'
        },
        {
          display: 'content',
          value: 'content'
        },
        {
          display: 'user count',
          value: 'user_count'
        },
        {
          display: 'login id',
          value: 'login_id'
        },
        {
          display: 'login name',
          value: 'login_name'
        },
        {
          display: 'level',
          value: 'level'
        },
        {
          display: 'agent',
          value: 'agent'
        },
        {
          display: 'admin',
          value: 'admin'
        },
        {
          display: 'created at',
          value: 'created_at'
        },
        {
          display: 'updated at',
          value: 'updated_at'
        },
        {
          display: 'deleted at',
          value: 'deleted_at'
        }
      ],

      quillTitleConfig: {
        placeholder: 'Title here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      },

      quillContentConfig: {
        placeholder: 'Content here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      }
    }
  },

  computed: {
    ...mapState('support', [ 'messages', 'messageCount' ]),
    ...mapState('user', [ 'users' ]),

    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    }
  },

  watch: {
    async $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate(this.query))
    }
  },

  async created () {
    this.query = this.generate(this.query)
    this.search()
  },

  methods: {
    ...mapActions('level', { getLevels: 'get' }),
    ...mapActions('code', { getCodeArchive: 'archive' }),
    ...mapActions('agent', { getAgentArchive: 'archive' }),
    ...mapActions('deposit-account', { getAccountArchive: 'archive' }),
    ...mapActions('support', { deleteSupport: 'deleteMessages' }),
    ...mapActions('support', { restoreSupport: 'restoreMessages' }),
    ...mapActions('support', { getMessage: 'get' }),
    ...mapActions('support', [ 'createMessages', 'getMessages', 'updateMessages' ]),
    ...mapActions('user', { getUsers: 'get' }),

    getReadAt (date) {
      return (date) ? date.read_at : null
    },

    getDefaultModel () {
      return {
        content: '',
        user_id: '',
        admin_id: '',
        betslip_id: null,
        title: '',
        user: null
      }
    },

    getUserCount (receiver) {
      if (receiver === 'all') {
        receiver = 'all'
      }

      if (receiver !== null &&
          receiver !== 'all') {
        receiver = JSON.parse(receiver)
        receiver = receiver.length
      }

      return receiver === null ? '-' : receiver
    },

    formatStatus (status) {
      let stat = ''
      switch (status.toUpperCase()) {
        case 'P': stat = 'Pending'
          break
        case 'W': stat = 'Waiting'
          break
        case 'R': stat = 'Resolved'
          break
        default: stat = ''
      }
      return stat
    },

    async search (query) {
      this.query = query || this.query
      this.filterStatus = this.$route.params.status

      this.selected = []

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.getMessages({ status: this.filterStatus, params: this.query })

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.messages.length) {
        this.isEmpty = true
      }
    },

    async trigger (query) {
      this.query = query || this.query
      this.$router.push({ query: this.query })
    },

    async addNewMessage () {
      let success = async () => {
        delete this.messageModel.user
        let result = await this.createMessages(this.messageModel)

        if (result.status === 201) {
          this.$alert('success', 'You have successfully created message(s).', {}, '', 'Success')
          this.showCreate = false
          this.messageModel = _.assign(this.messageModel, this.getDefaultModel())
          this.search()
        }
      }

      this.messageModel.user_id = this.messageModel.user.id
      this.messageModel.admin_id = parseInt(this.messageModel.admin_id, 10) || null
      this.messageModel.user_id = parseInt(this.messageModel.user_id, 10) || null
      this.messageModel.betslip_id = parseInt(this.messageModel.betslip_id, 10) || null

      if (this.messageModel.title === '' || this.messageModel.content === '' ||
          this.messageModel.user_id === null) {
        this.$alert('error', 'All fields required.', {}, '', 'Error')
        return
      }

      if (this.messageModel.title.replace(/(<([^>]+)>)/ig, ' ').trim() === '' ||
          this.messageModel.content.replace(/(<([^>]+)>)/ig, ' ').trim() === '' ||
          this.messageModel.user_id === null) {
        this.$alert('error', 'All fields required.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, 'Create Message')
    },

    async deleteMessages () {
      let success = async () => {
        let result = await this.deleteSupport(this.selected)

        if (result.status === 202) {
          this.$alert('success', 'You have successfully removed message(s).', {}, '', 'Success')
          this.selected = []
        }
      }

      this.$alert('prompt', 'Are you sure you want to remove message(s)?', {}, { success }, 'Remove Message')
    },

    async restoreMessages () {
      let success = async () => {
        let result = await this.restoreSupport(this.selected)

        if (result.status === 204) {
          this.$alert('success', 'You have successfully restored message(s).', {}, '', 'Success')
          this.selected = []
        }
      }

      this.$alert('prompt', 'Are you sure you want to restore message(s)?', {}, { success }, 'Restore Message')
    },

    async showModifyForm (index) {
      if (this.checkPermission) {
        const item = this.messages[index]

        if (item.condition !== 'user') {
          window.open(
            `${process.env.VUE_APP_URL}/support/messages/detail/${item.id}`,
            '',
            `width=${800},height=${800}`

          )
          return
        }
        this.selected.push(item.id)
        this.messageUpdateModel = _.assign(this.messageUpdateModel, item)
        this.showModify = true
      }
    },

    async saveModify () {
      let success = async () => {
        let result = await this.updateMessages(this.messageUpdateModel)

        if (result.status === 204) {
          this.$alert('success', 'You have successfully modified message(s).', {}, '', 'Success')
          this.selected = []
          this.messageUpdateModel = this.getDefaultModel()
          this.showModify = false
        }
      }

      if (this.messageUpdateModel.title === '' || this.messageUpdateModel.content === '') {
        this.$alert('error', 'All fields required.', {}, '', 'Error')
        return
      }

      if (this.messageUpdateModel.title.replace(/(<([^>]+)>)/ig, ' ').trim() === '' ||
          this.messageUpdateModel.content.replace(/(<([^>]+)>)/ig, ' ').trim() === '') {
        this.$alert('error', 'All fields required.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to modify the following message(s)?',
        {}, { success }, 'Modify Message')
    },

    async searchUser (q) {
      let params = { rows: 50, sortBy: 'id', sort: 'asc' }

      if (q) {
        params.filter_by = 'login_id'
        params.q = q
      }

      await this.getUsers({
        status: 'confirmed',
        params: params
      })
    },

    messageUser () {
      this.showMessageUser = true
      this.getLevels()
      this.getAgentArchive()
      this.getCodeArchive()
      this.getAccountArchive()
    },

    sort (sortBy) {
      if (this.query.sort === 'asc') {
        this.query.sort = 'desc'
      } else {
        this.query.sort = 'asc'
      }

      this.query.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.search()
    },

    openUser (id, subtype) {
      window.open(
        `${process.env.VUE_APP_URL}/user/${id}/${subtype}`,
        '',
        `width=${1400},height=${window.innerHeight}`
      )
    }
  }
}
</script>
